import { useEffect, useState } from "react";
import { ErrorScreenLayout } from "../common_components/ErrorScreenLayout";

export function NoInternetConnectionWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  const [isOffline, setIsOffline] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOffline(false);
    };

    const handleOffline = () => {
      setIsOffline(true);
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  if (isOffline) {
    return (
      <ErrorScreenLayout
        isLoading={false}
        info="Looks like you are offline :("
      />
    );
  }

  return <>{children}</>;
}
